import { render } from "./MovieList.vue?vue&type=template&id=8137a53c"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"

import "./MovieList.vue?vue&type=style&index=0&id=8137a53c&lang=css"

import exportComponent from "C:\\Users\\naska\\Desktop\\Javascript Portfolio Projects\\movie-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__